import UploadFile from "../../../utils/uploadFile";
import useSocket from "../../../hooks/useSocket";

const CartransferMobile = ({ roomId }) => {
  // Usar el hook personalizado para Socket.IO
  const { emit } = useSocket(roomId, {
    phone_connected: () => {}
  });

  const emitChange = (entity, data) => {
    emit("client_message", { room: roomId, entity, data });
  };

  return (
    <div>
      <h1>Carnet vendedor</h1>
      <UploadFile
        type={"image/*"}
        action="/parse-docs/fetch-ci"
        entity={"seller"}
        ws={emitChange}
        cartransferId={roomId}
      />
      <h1>Carnet comprador</h1>
      <UploadFile
        type={"image/*"}
        action="/parse-docs/fetch-ci"
        entity={"buyer"}
        ws={emitChange}
        cartransferId={roomId}
      />
      <h1>Cert antecedentes (PDF) </h1>
      <UploadFile
        type={"application/pdf"}
        action="/parse-docs/fetch-background"
        entity={"background"}
        ws={emitChange}
        cartransferId={roomId}
      />
      <h1>Cert antecedentes (Foto folio)</h1>
      <UploadFile
        type={"image/*"}
        action="/parse-docs/fetch-background-codes"
        entity={"background"}
        ws={emitChange}
        cartransferId={roomId}
      />
      <h1>Permiso circulación (PDF)</h1>
      <UploadFile
        type={"application/pdf"}
        entity={"permission"}
        action="/parse-docs/fetch-permission"
        ws={emitChange}
        cartransferId={roomId}
      />
      <h1>Permiso circulación (Foto)</h1>
      <UploadFile
        type={"image/*"}
        entity={"permission"}
        action="/cartransfers/folder"
        label="Subir foto respaldo"
        cartransferId={roomId}
      />
    </div>
  );
};

export default CartransferMobile;
